import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router';
import { connect, ConnectedProps, useDispatch, useSelector } from 'react-redux';
import PageHeader from 'Components/UI/PageHeader/PageHeader';
import Table from 'Components/UI/Table';
import BreadCrumb, { IBreadcrumbItem } from 'Components/UI/BreadCrumb';
import TableActionTopbar, {
  ITableActionTopbarButton
} from 'Components/UI/TableActionTopbar';
import { ColumnProps } from 'antd/lib/table';
import { Icon, IconName } from 'Components/UI';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { DisciplinaActions } from 'Store/Disciplina/Disciplina.actions';
import { ListagemArquivosActions } from 'Store/ListagemArquivos/ListagemArquivos.actions';
import { Popover } from 'antd';
import { ApisEnumLabel, getIconApi } from 'Data/enums/Apis';
import CadastroDisciplina from './Modals/CadastroDisciplina';
import toastHandler from 'Utils/toastHandler';
import ColumnHeader from 'Components/UI/Table/ColumnHeader';
import ExclusaoDisciplinas from './Modals/ExclusaoDisciplina';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import AccessPermission from 'Utils/AcessPermission';
import { mapNotification } from 'Utils/ObraUtils';
import { NotificationActions } from 'Store/Notification/Notification.actions';
import { INotificationsMapAux } from 'Data/interfaces/Notification/INotificationsMapAux';
import LoadingDisciplinas from 'Components/UI/CustomLoading/LoadingDisciplinas';
import { IUpdateDisciplineStatusRequest } from 'Data/interfaces/Obra/IUpdateDisciplineStatusRequest';
import {
  IListSaveOrder,
  saveOrderList,
} from 'Pages/ListagemArquivos/ListagemArquivos.helpers';
import AppStorage from 'Utils/AppStorage';
import TabsShell, { PathActiveEnum } from 'Components/UI/TabsShell';
import ModalBloquedSADownload from 'Components/UI/ModalBloquedSADownload';
import { ObraActions } from 'Store/Obra/Obra.actions';
import { Mixpanel } from 'Utils/MixPanel';
import TagIcon from 'Components/UI/TagIcon';
import ErrorSAConnection from './Modals/ErrorSAConnection';
import SolutionSAConnection from './Modals/SolutionSAConnection';
import { DisciplineFolderStatusEnum } from 'Data/interfaces/Obra/IDisciplineResponse';
import { IDisciplineSAStatusRequest } from 'Data/interfaces/Obra/IDisciplineSAStatusRequest';
import {
  INotificationInAppObra,
  INotificationMultipleReadRequest,
} from 'Data/interfaces/Notification/INotification';
import { getCurrentTenant, getTenants } from 'Store/Tenant/Tenant.selector';
import ReconnectIntegrationBox from 'Components/UI/ReconnectIntegrationBox';
import { useQueryInAppObraNotifications } from 'Hooks/notifications/useQueryInAppObraNotifications';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';
import { DotNotification } from 'Components/UI/Dot';
import { isObjectEmpty } from 'Utils/ObjectUtils';
import { Http } from 'Utils/Http';
import { useNotification } from 'Context/NotificationContext';
import MoreActionsDropdownContent from './components/MoreActionsDropdownContent';
import ContextMenu from 'Components/UI/ContextMenu';
import { IContextMenuRef } from 'Components/UI/ContextMenu/model';
import { useTimeout } from 'Context/TimeoutContext';
import { validateErrorMsg } from 'Store/Upload/Upload.sagas';
import { UploadActions } from 'Store/Upload/Upload.actions';
import { ActionColumn, DisciplineItem, TableWrapper } from './styles';

export const RELOAD_DISCIPLINAS_KEY = 'RELOAD_DISCIPLINAS_KEY';

export interface IOpenMoreActionsDropdown {
  open: boolean;
  id: number | null;
}

const DisciplineIcons: IconName[] = [
  'disciplinaArquitetura',
  'disciplinaEstrutura',
  'disciplinaEletrica',
  'disciplinaHidrossanitaria',
  'disciplinaMecanica',
  'disciplinaFundacao',
  'disciplinaAr',
  'disciplinaIncendio',
  'menuContexto'
];

export enum DisciplineIconsEnum {
  'Arquitetura' = 'disciplinaArquitetura',
  'Estrutura' = 'disciplinaEstrutura',
  'Instalações Eletricas e Sistemas' = 'disciplinaEletrica',
  'Instalações Hidrossanitarias' = 'disciplinaHidrossanitaria',
  'Instalações Mecânicas' = 'disciplinaMecanica',
  'Fundações' = 'disciplinaFundacao',
  'Ar Condicionado' = 'disciplinaAr',
  'Incêndio' = 'disciplinaIncendio',
  'Engineer' = 'menuContexto',
  'Arquivos obsoletos' = 'obsoleteArchive',
}

const breadCrumbs: IBreadcrumbItem[] = [];

const Disciplinas: FC<Props> = (props) => {
  const followDisciplineFeatureFlag = useFeatureFlag('follow-discipline-feature');
  const followDisciplineFeature = followDisciplineFeatureFlag.enabled && followDisciplineFeatureFlag.value === 'test';

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { set, clear } = useTimeout();
  const location = useLocation();
  const params = useParams();
  const {
    data: inAppNotifications,
  } = useQueryInAppObraNotifications(Number(params.constructionSiteId));
  const { addNotificationsToRead } = useNotification();

  const tenants = useSelector(getTenants);
  const currentTenant = useSelector(getCurrentTenant);

  const firstOpen = useRef(0);
  const hasCheckedReload = useRef(false);
  const contextMenuRef = useRef<IContextMenuRef>(null);
  const [selectedDisciplinas, setSelectedDisciplinas] = useState<number[]>([]);
  const [showErrorSAConnectionInfo, setShowErrorSAConnectionInfo] = useState(false);
  const [showSolutionSAConnection, setShowSolutionSAConnection] = useState(false);
  const [disciplineForSolution, setDisciplineForSolution] = useState<any>(null);
  const [sentSolutionSAConnection, setSentSolutionSAConnection] = useState(false);
  const [showCadastroDisciplina, setShowCadastroDisciplina] = useState(false);
  const [showModalExclusaoDisciplina, setShowModalExclusaoDisciplina] = useState(
    false
  );
  const [editedDisciplineId, setEditedDisciplineId] = useState<number>();
  const [editedDisciplineName, setEditedDisciplineName] = useState<string>();
  const [editedDisciplineIcon, setEditedDisciplineIcon] = useState<string>(
    'menuContexto'
  );
  const [openMoreActionsDropdown, setOpenMoreActionsDropdown] = useState<IOpenMoreActionsDropdown>({
    open: false,
    id: null,
  });
  const [contextMenuRecord, setContextMenuRecord] = useState<any | null>(null);
  const [canReadNow, setCanReadNow] = useState(false);

  const notificationsObj = useMemo(() => {
    const foldersIds = [];
    const notificationsMap: Record<string, INotificationInAppObra[]> = {};
    for (const notification of inAppNotifications) {
      if (notification.ItemId in notificationsMap) {
        notificationsMap[notification.ItemId].push(notification);
      } else {
        notificationsMap[notification.ItemId] = [notification];
      }
      if (notification?.Folders?.length > 0) {
        foldersIds.push(...notification.Folders, notification.ItemId);
      }
    }
    return { foldersIds, notificationsMap };
  }, [inAppNotifications]);

  const onChange = (selecteds: any) => setSelectedDisciplinas(selecteds);

  if (Http.GetQueryParams('SameAccountRequiredError') === 'true') {
    toastHandler.showError(
      'O email deve ser o mesmo da conta já conectada ao serviço de armazenamento.'
    );

    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete('SameAccountRequiredError');  // Remove the query parameter
    navigate({
      pathname: window.location.pathname,
      search: queryParams.toString() ? `?${queryParams.toString()}` : '',  // Update the URL
    });
  }

  useEffect(() => {
    return () => {
      clear('canReadNow');
      clear('hasUploadErrorRedirect');
    }
  }, []);

  useEffect(() => {
    if (
      firstOpen.current === 0
      && props.Obra
      && props.Obra.ConstructionSiteId === Number(params.constructionSiteId)
    ) {
      if (params.isNewConstructionSite === 'true') {
        toastHandler.showSuccess(
          'Obra criada com sucesso. Você já pode utilizar sua nova obra!'
        );
        const queryParams = new URLSearchParams(location.search);
        queryParams.delete('isNewConstructionSite');
        navigate({
          pathname: location.pathname,
          search: queryParams.toString() ? `?${queryParams.toString()}` : ''
        });
      }
      Mixpanel.track({
        name: 'PAGE_VIEW',
        props: {
          constructionSiteId: Number(params.constructionSiteId),
        },
        userInfo: props.userInfo,
        currentListTenant: currentTenant,
        tenantIds: tenants && tenants.length > 0
          ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
          : undefined,
      });
      firstOpen.current++;
    }
  }, [props.Obra]);

  useEffect(() => {
    if (AppStorage.GetItem('listDisciplinesOrder') && !props.isLoading) {
      const listDisciplinesSaveOrder: IListSaveOrder = JSON.parse(AppStorage.GetItem('listDisciplinesOrder') ?? '');
      sortDisciplinesList(listDisciplinesSaveOrder.sortOrder)
    }
  }, [props.isLoading]);

  useEffect(() => {
    if (!props.isLoading) {
      if (showCadastroDisciplina) {
        closeModalDiscipline();
      }
      setSelectedDisciplinas([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isLoading]);

  useEffect(() => {
    const pathname = location?.pathname || '';
    const search = location?.search;
    dispatch(ObraActions.storeArchivesPath({
      path: pathname,
      params,
      url: `${pathname}${search}`,
    }));
  }, [params, location, dispatch]);

  useEffect(() => {
    if (sentSolutionSAConnection && !props.isDisciplineSolutionLoading) {
      closeSoluctionSAConnection();
    }
  }, [props.isDisciplineSolutionLoading, sentSolutionSAConnection]);

  const editDiscipline = (id: number, name: string) => {
    setEditedDisciplineId(id);
    setEditedDisciplineName(name);
    setShowCadastroDisciplina(true);
  };

  const newDiscipline = () => {
    setEditedDisciplineId(undefined);
    setEditedDisciplineName(undefined);
    setShowCadastroDisciplina(true);
  };

  const closeModalDiscipline = () => {
    setShowCadastroDisciplina(false);
    setEditedDisciplineId(undefined);
    setEditedDisciplineName('');
  };

  const handleOpenMoreActionsDropdown = (id: number, open: boolean) => {
    if (!followDisciplineFeature) return;

    setOpenMoreActionsDropdown({
      open,
      id,
    });
  };

  const handleCloseMoreActionsDropdown = () => {
    setOpenMoreActionsDropdown({
      open: false,
      id: null,
    });
  };

  const toggleFollowDiscipline = (disciplines: any[]) => {
    if (disciplines.length === 0) return;

    console.log('toggleFollowDiscipline', disciplines);
  };

  const openModalExcluirDisciplina = (
    id: number,
    name: string,
    icon: string,
    folderId: string
  ) => {
    setEditedDisciplineId(id);
    setEditedDisciplineName(name);
    setEditedDisciplineIcon(icon);
    handleCloseMoreActionsDropdown();
    setShowModalExclusaoDisciplina(true);
    const request = {
      constructionSiteId: Number(params.constructionSiteId),
      folderId: folderId
    };
    dispatch(DisciplinaActions.listFilesOnDisciplineRequest(request));
  };

  const removeFiles = () => {
    setShowModalExclusaoDisciplina(false);
    const request = {
      ConstructionSiteId: Number(params.constructionSiteId),
      ConstructionSiteDisciplineId: editedDisciplineId
    };
    dispatch(DisciplinaActions.deleteDisciplineRequest(request))
  };

  const openDisciplineOnCloud = () => {
    setShowModalExclusaoDisciplina(false);
    window.open(props.Obra?.CloudServiceUrl, '_blank');
  };

  const forceListDisciplinesUpdate = (constructionSiteId: number) => {
    const request: IUpdateDisciplineStatusRequest = {
      csId: constructionSiteId,
      ignoreCache: true
    }
    dispatch(DisciplinaActions.list(request));
  }

  const handleShowErrorSAConnectionInfo = () => {
    setShowErrorSAConnectionInfo(!showErrorSAConnectionInfo);
  }

  const handleOpenSA = () => {
    if (!props.Obra?.CloudServiceUrl) return;

    window.open(props.Obra?.CloudServiceUrl, '_blank');

    Mixpanel.track({
      name: 'REDIRECT_SA_ACTION',
      props: {
        constructionSiteId: Number(params.constructionSiteId),
        api: props.Obra?.Api,
      },
      userInfo: props.userInfo,
      currentListTenant: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    });
  }

  const getActionsToolbar = (): ITableActionTopbarButton[] => {
    const selectedDisciplinasData = props.Obra?.Disciplines?.filter((discipline: any) => {
      return selectedDisciplinas?.includes(discipline.ConstructionSiteDisciplinesId);
    })
    const hasFollowedDisciplines = selectedDisciplinasData?.some((discipline: any) => {
      return discipline?.IsFollow ?? false;
    });

    return [
      {
        icon: hasFollowedDisciplines ? 'notVisualizar' : 'visualizar',
        iconCustomSize: hasFollowedDisciplines ? 18 : 12,
        description: hasFollowedDisciplines
          ? `Deixar de seguir disciplina${selectedDisciplinas.length > 1 ? 's' : ''}`
          : `Seguir disciplina${selectedDisciplinas.length > 1 ? 's' : ''}`,
        hidden: !followDisciplineFeature || selectedDisciplinas.length === 0,
        action: () => {
          toggleFollowDiscipline(selectedDisciplinas);
        }
      },
      {
        icon: getIconApi(props.Obra?.Api || 0),
        description: `Ver no ${ApisEnumLabel[props.Obra?.Api || 0]}`,
        hidden: !AccessPermission.downloadFiles(props.currentUserPrivileges) || AccessPermission.isEngOrConsult() || !props.Obra?.IsIntegrationAvailable,
        isBlocked: !props.Obra?.CloudServiceUrl,
        action: () => handleOpenSA(),
        dropdownMenu: props.Obra?.CloudServiceUrl
          ? undefined
          : (toggleDropdown: () => void) => (
            <ModalBloquedSADownload
              platform={props.Obra?.Api || 0}
              onCancel={() => toggleDropdown()}
            />
          )
      },
      {
        icon: 'atualizar',
        description: 'Atualizar',
        hidden: selectedDisciplinas.length > 0 || !props.Obra?.IsIntegrationAvailable,
        action: () => forceListDisciplinesUpdate(Number(params.constructionSiteId)),
      },
      {
        icon: 'arquivar',
        description: 'Nova disciplina',
        hidden: selectedDisciplinas.length > 0 || !AccessPermission.newOrEditDiscipline(props.currentUserPrivileges) || !props.Obra?.IsIntegrationAvailable,
        action: () => newDiscipline(),
      },
      {
        icon: 'editar',
        description: 'Editar',
        hidden:
          selectedDisciplinas.length !== 1 || !AccessPermission.newOrEditDiscipline(props.currentUserPrivileges),
        action: () => {
          const index = selectedDisciplinas[0];
          const discipline = props.Obra?.Disciplines[index];
          editDiscipline(
            discipline.ConstructionSiteDisciplinesId,
            discipline.CustomName || discipline.Discipline.Name
          );
        },
      },
      {
        icon: 'excluir',
        hidden: selectedDisciplinas.length !== 1 || !AccessPermission.deleteDiscipline(),
        action: () => {
          const index = selectedDisciplinas[0];
          const discipline = props.Obra?.Disciplines[index];
          openModalExcluirDisciplina(
            discipline.ConstructionSiteDisciplinesId,
            discipline.CustomName || discipline.Discipline.Name,
            discipline.Discipline.Icon,
            discipline.DisciplineApiFolderId
          );
        },
      },
    ];
  };

  const sortDisciplinesList = (sortOrder: boolean) => {
    saveOrderList('listDisciplinesOrder', 'CustomName', sortOrder)

    const sortedDisciplines = [
      ...(props.Obra?.Disciplines.sort((a: any, b: any) => {
        const propA = a['CustomName'] || a['Discipline']['Name'] || '';
        const propB = b['CustomName'] || b['Discipline']['Name'] || '';

        if (typeof propA === 'number' && typeof propB === 'number') {
          return sortOrder ? propB - propA : propA - propB;
        }

        return propA.toString().localeCompare(propB.toString()) * (sortOrder ? -1 : 1);
      }) || [])
    ];

    const dataSortedDisciplines: IObraResponse = props.Obra ?? ({} as IObraResponse);
    dataSortedDisciplines.Disciplines = sortedDisciplines;

    dispatch(DisciplinaActions.listUpdate(dataSortedDisciplines));
  };

  const handleSoluctionSAConnection = (discipline: any) => {
    const request: IDisciplineSAStatusRequest = {
      ConstructionSiteDisciplineId: discipline.ConstructionSiteDisciplinesId,
      csId: discipline.ConstructionSiteFk,
      fileApiId: discipline.DisciplineApiFolderId,
    };
    dispatch(DisciplinaActions.statusSADisciplineRequest(request))
    setDisciplineForSolution(discipline);
    setShowSolutionSAConnection(true);
  };

  const closeSoluctionSAConnection = () => {
    setDisciplineForSolution(null);
    setShowSolutionSAConnection(false);
  };

  const confirmSoluctionSAConnection = (
    sent: boolean,
  ) => {
    setSentSolutionSAConnection(sent);
  };

  const menuId = `ContextMenuDisciplina`;

  const handleContextMenu = (e: any, record: any) => {
    setContextMenuRecord(record);
    contextMenuRef.current?.show(e);
  }

  const columnsTable: Array<ColumnProps<any>> = [
    {
      title: (
        <ColumnHeader
          title="Nome"
          sorter={(sortDirection: boolean) => sortDisciplinesList(sortDirection)}
        />
      ),
      dataIndex: 'CustomName',
      render: (text, record) => {
        const errorConnection = DisciplineFolderStatusEnum.NotFound === record.FolderStatus;
        const hasNotification = notificationsObj?.notificationsMap?.hasOwnProperty(record.DisciplineApiFolderId) ||
          notificationsObj?.notificationsMap?.hasOwnProperty(`${record.ConstructionSiteDisciplinesId}`) ||
          notificationsObj?.foldersIds?.some(folderID => {
            return folderID === record.DisciplineApiFolderId || folderID === `${record.ConstructionSiteDisciplinesId}`;
          });

        return (
          <div onContextMenu={(e) => handleContextMenu(e, record)}>
            <DisciplineItem
              error={errorConnection}
              onClick={() =>
                errorConnection
                  ? handleShowErrorSAConnectionInfo()
                  : navigate(
                    `/obras/filelist/${record.ConstructionSiteFk}/${record.DisciplineApiFolderId}?obraApi=${props.Obra?.Api}&folderName=${text ?? record.Discipline.Name}&ConstructionSiteDisciplinesId=${record.ConstructionSiteDisciplinesId}&DisciplineName=${record.CustomName || record.Discipline.Name}`
                  )
              }
            >
              <ErrorSAConnection
                platform={props.Obra?.Api || 0}
                userRole={props.userInfo?.CurrentRoleFk}
                onAction={() => handleSoluctionSAConnection(record)}
                triggered={showSolutionSAConnection || !errorConnection}
              >
                <Icon
                  error={errorConnection}
                  color="cinzaPadrao"
                  icon={DisciplineIcons[record.Discipline.DisciplineId - 1] || 'menuContexto'}
                  customSize={20}
                />
                <span className="disciplineItemText">
                  {text ?? record.Discipline.Name}
                </span>
                {hasNotification && (
                  <span className="dotWrapper"><DotNotification /></span>
                )}
                {errorConnection ? (
                  <TagIcon
                    text="erro de conexão"
                    icon={<Icon icon="aviso" color="branco" customSize={12} />}
                    error={errorConnection}
                    onClick={handleShowErrorSAConnectionInfo}
                  />
                ) : null}
              </ErrorSAConnection>
            </DisciplineItem>
          </div>
        )
      }
    },
    {
      title: (
        followDisciplineFeature ? (
          <ColumnHeader
            title={''}
            showOrder={false}
          />
        ) : null
      ),
      width: followDisciplineFeature ? undefined : '0%',
      className: 'columnAction',
      dataIndex: 'Action',
      render: (status: number, record: any) => {
        if (!followDisciplineFeature) return null;

        return (
          <ActionColumn>
            <Popover
              open={openMoreActionsDropdown.open &&
                openMoreActionsDropdown.id === record.ConstructionSiteDisciplinesId}
              trigger="click"
              placement="left"
              className="popoverMoreActions"
              content={
                <MoreActionsDropdownContent
                  preferencesFeature={followDisciplineFeature}
                  record={record}
                  apiText={`Ver no ${ApisEnumLabel[props.Obra?.Api || 0]}`}
                  onToggleFollow={toggleFollowDiscipline}
                  onEdit={editDiscipline}
                  onOpenSA={handleOpenSA}
                  onOpenHistoryDrawer={() => undefined}
                  onOpenModalExclusao={openModalExcluirDisciplina}
                />
              }
              onOpenChange={(open) => handleOpenMoreActionsDropdown(
                record.ConstructionSiteDisciplinesId,
                open
              )}
              overlayInnerStyle={{ padding: 0 }}
            >
              <div className="iconWrapper">
                <Icon icon="moreActions" className="iconAction" />
              </div>
            </Popover>
          </ActionColumn>
        );
      },
    },
  ];

  const rowSelection = {
    selectedDisciplinas,
    onChange
  };

  useEffect(() => {
    if (params.constructionSiteId) {
      const request: IUpdateDisciplineStatusRequest = {
        csId: Number(params.constructionSiteId)
      }

      if (!hasCheckedReload.current) {
        if (!(window as any)[RELOAD_DISCIPLINAS_KEY]) {
          request.ignoreCache = true;
          (window as any)[RELOAD_DISCIPLINAS_KEY] = true;
        }
        hasCheckedReload.current = true;
      }

      dispatch(DisciplinaActions.list(request));
    }
    dispatch(ListagemArquivosActions.setShowPlotRequestTable(false));
  }, [params.constructionSiteId]);

  useEffect(() => {
    if (
      !!props.checkUploadErrorMsg &&
      props.checkUploadErrorMsg.toLowerCase().includes(validateErrorMsg.toLowerCase())
    ) {
      clear('hasUploadErrorRedirect');
      set('hasUploadErrorRedirect', () => {
        forceListDisciplinesUpdate(Number(params.constructionSiteId));
        dispatch(UploadActions.clearErrorMsg());
      }, 200);
    }
  }, [props?.checkUploadErrorMsg, params.constructionSiteId]);

  useEffect(() => {
    // Marcar novas notificações como 'vistas'
    if (
      !props.isLoading &&
      params?.constructionSiteId &&
      !isObjectEmpty(notificationsObj) &&
      props.Obra?.Disciplines &&
      props.Obra?.Disciplines?.length > 0
    ) {
      if (!canReadNow) {
        clear('canReadNow');
        set('canReadNow', () => {
          setCanReadNow(true);
        }, 600);
      } else {
        const disciplinesHasNotifications: INotificationInAppObra[] = [];
        const notificationAsView: INotificationMultipleReadRequest = {
          constructionSiteId: Number(params.constructionSiteId),
          notificationIds: []
        };
        for (const notification of inAppNotifications) {
          if (notification.Folders.length > 0) {
            const lastFolderId = notification.Folders[notification.Folders.length - 1];
            if (lastFolderId === params.folderId) {
              notificationAsView.notificationIds.push(notification.NotificationId);
            } else {
              const findFolderIndex = notification.Folders.findIndex(folder => folder === params.folderId)
              if (findFolderIndex !== -1) {
                const afterFolder = notification.Folders[findFolderIndex + 1]
                if (afterFolder) {
                  const findFileIndex = props.Obra?.Disciplines.findIndex((discipline: any) => {
                    return discipline.DisciplineApiFolderId === afterFolder ||
                      `${discipline.ConstructionSiteDisciplinesId}` === afterFolder;
                  })
                  if (findFileIndex === -1) {
                    notificationAsView.notificationIds.push(notification.NotificationId);
                  }
                }
              }
            }
          }
          if (props.Obra?.Disciplines.some((discipline: any) => {
            return discipline.DisciplineApiFolderId === notification.ItemId ||
              `${discipline.ConstructionSiteDisciplinesId}` === notification.ItemId;
          })) {
            disciplinesHasNotifications.push(notification);
          }
        }
        for (const disciplineNotification of disciplinesHasNotifications) {
          if (!notificationAsView.notificationIds.includes(disciplineNotification.NotificationId)) {
            notificationAsView.notificationIds.push(disciplineNotification.NotificationId);
          }
        }
        if (notificationAsView.notificationIds.length > 0) {
          addNotificationsToRead(
            `discipline-list-${params?.constructionSiteId}`,
            notificationAsView,
          );
        }
      }
    }
  }, [
    props.Obra?.Disciplines,
    props.isLoading,
    notificationsObj,
    params?.constructionSiteId,
    addNotificationsToRead,
    canReadNow,
  ]);

  if (props.Obra) {
    breadCrumbs[0] = {
      href: `/obras/detail/${props.Obra.ConstructionSiteId}`,
      description: props.Obra.Name,
    };
    breadCrumbs[1] = {
      href: `/obras/detail/${props.Obra.ConstructionSiteId}`,
      description: 'Arquivos',
    };
  } else {
    breadCrumbs[0] = {
      href: '',
      isLoading: props.isLoading,
    };
    breadCrumbs[1] = {
      href: '',
      isLoading: props.isLoading,
    };
  }

  return (
    <>
      <TabsShell
        ConstructionSiteId={params.constructionSiteId}
        active={PathActiveEnum.detail}
        loading={props.isLoading}
      />
      <PageHeader name="Disciplinas">
        <BreadCrumb breadcrumbs={breadCrumbs} />
        <TableWrapper>
          <TableActionTopbar buttons={(props.Obra && getActionsToolbar()) || []} />
          {props.isLoading ? (
            <LoadingDisciplinas multiple={6} />
          ) : (
            !props.Obra?.IsIntegrationAvailable ?
              <ReconnectIntegrationBox
                integrationEmail={props.Obra?.IntegrationEmail!}
                serviceName='Google Drive'
                showReconnectButton={AccessPermission.isAdmin() || AccessPermission.isCoordenador()}
                csId={props.Obra?.ConstructionSiteId!}
                api={props.Obra?.Api!} />
              :
              <Table
                columns={columnsTable}
                dataSource={props.Obra?.Disciplines.map(
                  (discipline: any, index: number) => ({ ...discipline, key: index })
                )}
                isSpaced={true}
                rowSelection={rowSelection}
              />
          )}
        </TableWrapper>

        <ContextMenu
          ref={contextMenuRef}
          id={menuId}
          menuHeight={followDisciplineFeature ? 176 : 127}
          menuWidth={208}
        >
          <MoreActionsDropdownContent
            preferencesFeature={followDisciplineFeature}
            record={contextMenuRecord}
            apiText={`Ver no ${ApisEnumLabel[props.Obra?.Api || 0]}`}
            onToggleFollow={toggleFollowDiscipline}
            onEdit={editDiscipline}
            onOpenSA={handleOpenSA}
            onOpenHistoryDrawer={() => undefined}
            onOpenModalExclusao={openModalExcluirDisciplina}
          />
        </ContextMenu>
      </PageHeader>
      {showCadastroDisciplina && (
        <CadastroDisciplina
          loading={props.isLoading}
          constructionSiteId={props.Obra?.ConstructionSiteId || 0}
          id={editedDisciplineId}
          description={editedDisciplineName}
          visible={showCadastroDisciplina}
          onCancel={closeModalDiscipline}
        />
      )}
      <ExclusaoDisciplinas
        isLoading={props.isLoading}
        disciplineFiles={props.disciplineContainsFile}
        id={editedDisciplineId}
        icon={editedDisciplineIcon}
        constructionSiteId={props.Obra?.ConstructionSiteId || 0}
        name={editedDisciplineName}
        visible={showModalExclusaoDisciplina}
        onCancel={() => setShowModalExclusaoDisciplina(false)}
        onConfirmDelete={removeFiles}
        onConfirmOpenDiscipline={openDisciplineOnCloud}
      />
      {showSolutionSAConnection && disciplineForSolution && (
        <SolutionSAConnection
          platform={props.Obra?.Api || 0}
          visible={showSolutionSAConnection}
          onCancel={closeSoluctionSAConnection}
          onConfirm={confirmSoluctionSAConnection}
          isLoading={props.isDisciplineSolutionLoading}
          isLoadingStatus={props.isDisciplineStatusSALoading}
          discipline={disciplineForSolution}
          disciplineStatus={props.disciplineSAStatus}
          existingFolderApiId={props.existingFolderApiId}
          dispatch={dispatch}
        />
      )}
    </>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.disciplina,
  currentUserPrivileges: state.listagemArquivos.currentUserPrivileges,
  userInfo: state.auth.userInfo,
  checkUploadErrorMsg: state.upload.error,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(Disciplinas);
